import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const PlatformAuthContext = createContext(null);

export const PlatformAuthProvider = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(false);
  const [platformAdmin, setPlatformAdmin] = useState(null);

  const fetchMe = useCallback(async () => {
    try {
      const res = await axios.get('/api/platform_admin/auth/me', {
        withCredentials: true,
      });

      const data = res.data || {};

      if (data.ok && data.is_platform_admin === true) {
        setIsPlatformAdmin(true);
        setPlatformAdmin(data.platform_admin || null);
      } else {
        setIsPlatformAdmin(false);
        setPlatformAdmin(null);
      }
    } catch (err) {
      setIsPlatformAdmin(false);
      setPlatformAdmin(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMe();
  }, [fetchMe]);

  const refreshPlatformAuth = async () => {
    setLoading(true);
    await fetchMe();
  };

  return (
    <PlatformAuthContext.Provider
      value={{
        loading,
        isPlatformAdmin,
        platformAdmin,
        refreshPlatformAuth,
        setIsPlatformAdmin,
        setPlatformAdmin,
      }}
    >
      {children}
    </PlatformAuthContext.Provider>
  );
};

export const usePlatformAuth = () => {
  const context = useContext(PlatformAuthContext);
  if (!context) {
    throw new Error('usePlatformAuth must be used within a PlatformAuthProvider');
  }
  return context;
};